export const HISTORY_KIND = {
  DEPOSIT: 'deposit',
  WITHDRAW: 'withdraw',
  BET: 'bet',
  WINNING: 'winning',
} as const;
